import React from 'react';
import ActivateForm from './components/ActivateForm';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthAPI } from '../../api';
import AuthFormPage from './components/AuthFormPage';

const ProviderActivatePage = () => {
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const username = query.get('username');
  const code = query.get('code');
  return (
    <AuthFormPage title="Clickability Provider Account Activation">
      <ActivateForm
        username={username}
        code={code}
        onComplete={() => history.push('/providers/login?username=' + username)}
        activateApi={AuthAPI.providerActivate}
      />
    </AuthFormPage>
  );
};

export default ProviderActivatePage;
